module.exports = __webpack_public_path__ + "img/minus-s.57117be1.svg";